<template>
  <div class="settings-panel__container" v-if="activeGroup">
    <div class="setting-section">
      <p class="setting-section__h">Настройки группы</p>

      <div class="setting-row">
        <label>Направление</label>
        <Multiselect
          v-model="localSettings.flex.id"
          :options="flexDirectionOptions"
          placeholder="Направление"
          @update:modelValue="updateGroup"
        />
      </div>

      <div class="setting-row">
        <label>По горизонтали</label>
        <Multiselect
          v-model="localSettings.flex.justify_id"
          :options="justifyContentOptions"
          placeholder="Выравнивание"
          @update:modelValue="updateGroup"
        />
      </div>

      <div class="setting-row">
        <label>По вертикали</label>
        <Multiselect
          v-model="localSettings.flex.align"
          :options="alignItemsOptions"
          placeholder="Выравнивание"
          @update:modelValue="updateGroup"
        />
      </div>

      <div class="setting-row">
        <label>Перенос</label>
        <Multiselect
          v-model="localSettings.flex.wrap"
          :options="flexWrapOptions"
          placeholder="Перенос"
          @update:modelValue="updateGroup"
        />
      </div>
    </div>

    <div class="setting-section">
      <p class="setting-section__h">Цвет</p>
      <div class="setting-row">
        <label>Фон</label>
        <div class="setting-column">
          <ColorPicker
            :model-value="localSettings.backgroundColor"
            @update:model-value="updateBackgroundColor"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Multiselect from "@/components/UI/Select/Multiselect.vue";
import ColorPicker from "@/components/UI/ColorPicker/index.vue";

export default {
  name: "GroupSettings",
  components: { Multiselect, ColorPicker },
  data() {
    return {
      localSettings: {
        flex: {
          id: 0,
          justify_id: 0,
          align: 0,
          wrap: 0
        },
        backgroundColor: "transparent"
      },
      debugMode: false // Включите для отладки
    };
  },
  computed: {
    activeGroup() {
      return this.$store.getters["activeElement/activeGroup"];
    },
    
    flexDirectionOptions() {
      return [
        { label: "Слева направо", value: 0 },
        { label: "Справа налево", value: 1 },
        { label: "Сверху вниз", value: 2 },
        { label: "Снизу вверх", value: 3 },
      ];
    },
    
    justifyContentOptions() {
      return [
        { label: "По началу", value: 0 },
        { label: "По концу", value: 1 },
        { label: "По центру", value: 2 },
        { label: "Равные промежутки между элементами", value: 3 },
        { label: "Равные промежутки вокруг элементов", value: 4 },
        { label: "Равные промежутки между и вокруг элементов", value: 5 },
      ];
    },
    
    alignItemsOptions() {
      return [
        { label: "Растянуть на всю высоту", value: 0 },
        { label: "Выровнять по началу", value: 1 },
        { label: "Выровнять по концу", value: 2 },
        { label: "По центру", value: 3 },
        { label: "По базовой линии текста", value: 4 },
      ];
    },
    
    flexWrapOptions() {
      return [
        { label: "Без переноса", value: 0 },
        { label: "Перенос", value: 1 },
        { label: "Обратный перенос", value: 2 },
      ];
    }
  },
  watch: {
    activeGroup: {
      immediate: true,
      handler(newGroup) {
        if (newGroup && newGroup.settings) {
          // Копируем настройки группы в локальное состояние
          this.localSettings = {
            flex: { ...newGroup.settings.flex },
            backgroundColor: newGroup.settings.backgroundColor || "transparent"
          };
        }
      }
    }
  },
  methods: {
    copyId(text) { 
      if (!text) 
        return Promise.resolve(); 
        if (navigator.clipboard && window.isSecureContext) 
          return navigator.clipboard.writeText(text); 
          const ta = document.createElement('textarea'); 
          ta.value = text; 
          ta.style.position = 'fixed'; 
          ta.style.left = '-9999px'; 
          document.body.appendChild(ta); 
          ta.focus(); 
          ta.select(); 
          try { 
            document.execCommand('copy'); 
          } 
          catch(e) {} 
          document.body.removeChild(ta); return Promise.resolve(); 
    },
    updateGroup() {
      if (!this.activeGroup) return;
      
      // Создаем обновленную группу
      const updatedGroup = {
        ...this.activeGroup,
        settings: {
          ...this.activeGroup.settings,
          flex: { ...this.localSettings.flex },
          backgroundColor: this.localSettings.backgroundColor
        }
      };
      
      // Отправляем в хранилище
      this.$store.dispatch("activeElement/UPDATE_ACTIVE_GROUP", updatedGroup);
      
      // Также обновляем группу в основном состоянии приложения
      this.$store.dispatch("landing/UPDATE_GROUP", updatedGroup);
    },
    
    updateBackgroundColor(color) {
      this.localSettings.backgroundColor = color;
      this.updateGroup();
    }
  }
};
</script>

<style scoped>
.setting-section {
  padding-bottom: 0.5rem;
  margin-top: 0.5rem;
  border-bottom: 0.1rem solid var(--grey-0);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.setting-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.setting-column {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.setting-section__h {
  text-align: start;
  font-weight: bold;
}

.debug-info {
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 0.8rem;
}

.debug-info pre {
  white-space: pre-wrap;
  word-break: break-all;
}
</style>